import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ProductFishCake = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M10.5 19.5C10.1 19.5 9.59997 19.3 9.29997 19L4.99997 14.7C4.59997 14.3 4.39997 13.7 4.49997 13.1C4.59997 12.5 4.99997 12.1 5.59997 11.8C5.79997 11.8 5.99997 11.7 6.19997 11.6C6.59997 11.5 6.99997 11.2 7.09997 10.7C7.29997 9.9 7.69997 9.3 8.19997 8.7C8.69997 8.2 9.39997 7.8 10.2 7.6C10.6 7.5 11 7.2 11.1 6.7C11.3 5.9 11.7 5.3 12.2 4.7C12.8 4.2 13.4 3.8 14.2 3.6C14.6 3.5 15 3.2 15.1 2.7C15.1 2.5 15.2 2.3 15.3 2.1C15.5 1.6 16 1.1 16.6 0.999996C17.2 0.899996 17.7 0.999996 18.2 1.5L22.5 5.8C22.9 6.2 23.1 6.8 23 7.4C22.9 8 22.5 8.4 21.9 8.7C21.7 8.7 21.5 8.8 21.3 8.9C20.9 9 20.5 9.3 20.4 9.8C20.2 10.6 19.8 11.2 19.3 11.8C18.8 12.4 18.1 12.7 17.3 12.9C16.9 12.9 16.5 13.3 16.4 13.8C16.2 14.6 15.8 15.2 15.3 15.8C14.8 16.4 14.1 16.7 13.3 16.9C12.9 16.9 12.5 17.3 12.4 17.8C12.4 18 12.3 18.2 12.2 18.4C12 18.9 11.5 19.4 10.9 19.5C10.8 19.5 10.7 19.5 10.5 19.5ZM16.5 2.9C16.5 3 16.5 3.1 16.4 3.3C16.2 4.3 15.4 5.1 14.4 5.3C13.9 5.4 13.5 5.7 13.1 6C12.7 6.4 12.5 6.8 12.4 7.3C12.2 8.3 11.4 9.1 10.4 9.3C9.89997 9.4 9.49997 9.7 9.09997 10C8.69997 10.3 8.49997 10.8 8.39997 11.3C8.19997 12.3 7.39997 13.1 6.39997 13.3C6.29997 13.3 6.19997 13.3 5.99997 13.4C5.89997 13.4 5.89997 13.5 5.89997 13.6C5.89997 13.6 5.89997 13.7 5.89997 13.8L10.2 18.1C10.2 18.1 10.3 18.1 10.4 18.1C10.4 18.1 10.5 18.1 10.6 18C10.6 17.9 10.6 17.8 10.7 17.6C10.9 16.6 11.7 15.8 12.7 15.6C13.2 15.5 13.6 15.2 14 14.9C14.4 14.6 14.6 14.1 14.7 13.6C14.9 12.6 15.7 11.8 16.7 11.6C17.2 11.5 17.6 11.2 18 10.9C18.4 10.6 18.6 10.1 18.7 9.6C18.9 8.6 19.7 7.8 20.7 7.6C20.8 7.6 20.9 7.6 21.1 7.5C21.2 7.5 21.2 7.4 21.2 7.3C21.2 7.3 21.2 7.2 21.2 7.1L16.9 2.8C16.9 2.8 16.8 2.8 16.7 2.8C16.7 2.8 16.6 2.8 16.5 2.9Z"
        fill={color}
      />
      <path
        d="M10.2 14.6C9.99998 14.6 9.79998 14.6 9.69998 14.4C9.39998 14.1 9.39998 13.6 9.69998 13.3L12 11C12.3 10.7 12.8 10.7 13.1 11C13.4 11.3 13.4 11.8 13.1 12.1L10.8 14.4C10.7 14.5 10.5 14.6 10.3 14.6H10.2Z"
        fill={color}
      />
      <path
        d="M14.7 9.99999C14.5 9.99999 14.3 9.99999 14.2 9.79999C13.9 9.49999 13.9 8.99999 14.2 8.69999L16.5 6.39999C16.8 6.09999 17.3 6.09999 17.6 6.39999C17.9 6.69999 17.9 7.19999 17.6 7.49999L15.3 9.79999C15.2 9.89999 15 9.99999 14.8 9.99999H14.7Z"
        fill={color}
      />
      <path
        d="M2.00002 22.8C1.80002 22.8 1.60002 22.8 1.50002 22.6C1.20002 22.3 1.20002 21.8 1.50002 21.5L7.10002 15.9C7.40002 15.6 7.90002 15.6 8.20002 15.9C8.50002 16.2 8.50002 16.7 8.20002 17L2.60002 22.6C2.50002 22.7 2.30002 22.8 2.10002 22.8H2.00002Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ProductFishCake.displayName = 'ProductFishCake';
